module.exports = __webpack_public_path__ + "images/smartphone-screen-1_ba88456da0af0ad7f833149b9f49a21d.png";